export default __webpack_public_path__ + "static/media/footer-logo@2x.fbc00c05.png";